/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenResponseModel } from '../../models/token-response-model';

export interface ServiceTokenGetGet$Params {
}

export function serviceTokenGetGet(http: HttpClient, rootUrl: string, params?: ServiceTokenGetGet$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<TokenResponseModel>> {
  const rb = new RequestBuilder(rootUrl, serviceTokenGetGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<TokenResponseModel>;
    })
  );
}

serviceTokenGetGet.PATH = '/ServiceToken/Get';
